import React from "react";

const RefundAndCancellationPolicy = () => {
  return (
    <div
      style={{
        padding: "20px",
        fontFamily: "Arial, sans-serif",
        lineHeight: "1.6",
      }}
    >
      <h1>Refund & Cancellation Policy</h1>
      <p>
        At <strong>Janus Food Products</strong>, we strive to provide the best
        quality products and service. Please read our refund and cancellation
        policy carefully before placing an order.
      </p>

      {/* Cancellation Policy */}
      <section style={{ marginTop: "30px" }}>
        <h2>Order Cancellation Policy</h2>
        <p>
          Orders can be cancelled within <strong>24 hours</strong> of placement,
          provided they have not been dispatched.
        </p>
        <ul>
          <li>Orders that are shipped cannot be cancelled.</li>
          <li>
            To cancel an order, please email us at{" "}
            <a href="mailto: janusfoodproducts009@gmail.com">
              janusfoodproducts009@gmail.com
            </a>{" "}
            or call our customer care team.
          </li>
          <li>
            Approved cancellations will be refunded within{" "}
            <strong>7–10 business days</strong> to your original payment method.
          </li>
        </ul>
      </section>

      {/* Refund Policy */}
      <section style={{ marginTop: "30px" }}>
        <h2>Refund & Return Policy</h2>
        <p>We accept refund requests only under the following conditions:</p>
        <ul>
          <li>Wrong product delivered.</li>
          <li>
            Damaged or defective product (must be reported within{" "}
            <strong>48 hours of delivery</strong> with photo evidence).
          </li>
        </ul>
        <p>
          Once verified, refunds will be processed within{" "}
          <strong>7–10 business days</strong> to your original payment method.
        </p>

        <h4>Non-Returnable Items:</h4>
        <ul>
          <li>Perishable food items once opened or used.</li>
          <li>Custom-made or personalized products.</li>
          <li>Items purchased during clearance or sale.</li>
        </ul>

        <h4>Exchange Policy:</h4>
        <p>
          Exchanges are permitted only for defective or incorrect items after
          review by our quality team.
        </p>
      </section>

      <section style={{ marginTop: "20px" }}>
        <h3>Need Assistance?</h3>
        <p>
          For queries or support, contact us at:{" "}
          <a href="mailto: janusfoodproducts009@gmail.com">
            janusfoodproducts009@gmail.com
          </a>
        </p>
      </section>
    </div>
  );
};

export default RefundAndCancellationPolicy;
